let React;

const indexOf = [].indexOf ||
  function(item) {
    for (let i = 0, l = this.length; i < l; i++) {
      if (i in this && this[i] === item) return i;
    }
    return -1;
  };

React = require("react");

class Split_Button extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonState: null,
    };
  }

  showOptions() {
    return this.setState({
      buttonState: "split",
    });
  }

  componentWillReceiveProps(nextProps) {
    let ref;
    if ((ref = nextProps.buttonState) === "success" || ref === "failure") {
      return setTimeout(
        (_this => () => {
          _this.props.resetState();
          return _this.setState({
            buttonState: null,
          });
        })(this),
        3000,
      );
    }
  }

  render() {
    const colors = ["white", "green", "blue", "purple", "black"];
    const widths = ["small", "wide", "full-width"];
    let colorClass;
    let containerClass;
    let extraClass;
    let initialButtonClass;
    let ref;
    let ref1;
    let splitButtonClass;
    let status;
    let widthClass;
    if (this.props.buttonState) {
      status = this.props.buttonState.toLowerCase();
    } else {
      status = "initial";
    }
    colorClass = "";
    if ((ref = this.props.color, indexOf.call(colors, ref) >= 0)) {
      colorClass = this.props.color;
    }
    widthClass = "";
    if ((ref1 = this.props.widthClass, indexOf.call(widths, ref1) >= 0)) {
      widthClass = this.props.widthClass;
    }
    extraClass = "";
    if (this.props.extraClass) {
      extraClass = this.props.extraClass;
    }
    containerClass = ["split-button-container", widthClass];
    splitButtonClass = ["button", "split", this.props.iconClass];
    initialButtonClass = [
      "first-state",
      "button",
      "button-process",
      "button-icon",
      this.props.iconClass,
      widthClass,
      extraClass,
    ];
    if (
      status === "success" || status === "failure" || status === "processing"
    ) {
      initialButtonClass.push(status);
      initialButtonClass.push(colorClass);
      if (status === "processing") {
        containerClass.push(status);
      }
      initialButtonClass.splice(initialButtonClass.indexOf("button-icon"), 1);
    } else if (this.state.buttonState === "split") {
      initialButtonClass.push("wait");
      initialButtonClass.push(colorClass);
      splitButtonClass.push("visible");
    }
    return (
      <div className={containerClass.join(" ")}>
        <button
          onClick={this.props.rightButtonCallback.bind(this)}
          className={`first ${splitButtonClass.join(" ")}`}
        >
          {this.props.rightButtonText}
        </button>
        <button
          onClick={this.showOptions.bind(this)}
          className={initialButtonClass.join(" ")}
        >
          <span>{this.props.initialButtonText}</span>
        </button>
        <button
          onClick={this.props.leftButtonCallback.bind(this)}
          className={`second ${splitButtonClass.join(" ")}`}
        >
          {this.props.leftButtonText}
        </button>
      </div>
    );
  }
}

export default Split_Button;
